module.exports = __webpack_public_path__ + "media/images/animations/tire_widths/4-644be1d65e6ad71b51a38c9a186315f8.png";